import { render, staticRenderFns } from "./ventes.html?vue&type=template&id=7dc01ffa&scoped=true&external"
import script from "./ventes.js?vue&type=script&lang=js&external"
export * from "./ventes.js?vue&type=script&lang=js&external"
import style0 from "./ventes.scss?vue&type=style&index=0&id=7dc01ffa&prod&scoped=true&lang=scss&external"
import style1 from "./ventes-modal-choices.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc01ffa",
  null
  
)

export default component.exports